import { render, staticRenderFns } from "./actuals_perf_help.vue?vue&type=template&id=6ec00f01&scoped=true&"
import script from "./actuals_perf_help.vue?vue&type=script&lang=js&"
export * from "./actuals_perf_help.vue?vue&type=script&lang=js&"
import style0 from "./actuals_perf_help.vue?vue&type=style&index=0&id=6ec00f01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec00f01",
  null
  
)

export default component.exports